import React from 'react';
import './style.scss';

/**
 * CloudinaryVideo component for displaying videos from Cloudinary
 * @param {Object} props
 * @param {Object} props.video - The video resource object from Cloudinary
 * @param {Boolean} props.autoplay - Whether to autoplay the video (default: false)
 * @param {Boolean} props.loop - Whether to loop the video (default: true)
 * @param {Boolean} props.controls - Whether to show controls (default: true)
 * @param {Boolean} props.muted - Whether to mute the video (default: true)
 */
const CloudinaryVideo = ({
  video,
  autoplay = true,
  loop = true,
  controls = true,
  muted = true,
  className = ''
}) => {
  if (!video) return null;

  // Format Cloudinary URL for video
  const videoUrl = `https://res.cloudinary.com/dlkzchunj/video/upload/${video.public_id}.${video.format || 'mp4'}`;

  return (
    <div className={`cloudinary-video-container ${className}`}>
      <video
        src={videoUrl}
        className="cloudinary-video"
        autoPlay={autoplay}
        loop={loop}
        controls={controls}
        muted={muted}
        playsInline
      />
    </div>
  );
};

export default CloudinaryVideo;
